// === ALNAP START === Demo público (acceso vía token compartido)
// ----------------------------------------------------------------------------
// Página accesible SIN autenticación si el token de share-link es válido.
// Ruta: /alnap-public/:token
// El token se genera desde el modal "Compartir Demo" del AlnapDemoPage.
// ----------------------------------------------------------------------------
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Loader2, AlertCircle, ShieldX } from "lucide-react";
import AlnapDemoPage from "./AlnapDemoPage";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AlnapPublicPage() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [meta, setMeta] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/alnap/public/${token}`);
        const data = await r.json();
        if (!active) return;
        if (!r.ok) {
          setErrorMsg(data?.detail || "Enlace no válido o expirado");
          setStatus("error");
          return;
        }
        setMeta(data);
        setStatus("ok");
      } catch {
        if (!active) return;
        setErrorMsg("No se pudo cargar la demostración");
        setStatus("error");
      }
    })();
    return () => { active = false; };
  }, [token]);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50">
        <div className="text-center">
          <Loader2 className="w-10 h-10 mx-auto mb-3 animate-spin text-[#193966]" />
          <p className="text-sm text-slate-500">Cargando demostración…</p>
        </div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-50 p-6">
        <div className="max-w-md text-center bg-white rounded-2xl shadow-xl p-10 border border-slate-200" data-testid="alnap-public-error">
          <div className="w-16 h-16 mx-auto rounded-full bg-rose-100 flex items-center justify-center mb-4">
            <ShieldX className="w-8 h-8 text-rose-600" />
          </div>
          <h2 className="text-xl font-bold text-slate-800 mb-2">Enlace no disponible</h2>
          <p className="text-sm text-slate-600 mb-1">{errorMsg}</p>
          <p className="text-xs text-slate-400 mt-4 italic">
            Por favor solicite un nuevo enlace al equipo comercial de QAsesores.
          </p>
          <div className="mt-6 pt-6 border-t border-slate-100 text-[11px] text-slate-400">
            QAsesores Corredores de Seguros y Reaseguros SRL<br />
            info@qasesores.com.do
          </div>
        </div>
      </div>
    );
  }

  return <AlnapDemoPage publicToken={token} publicMeta={meta} />;
}
// === ALNAP END ===
